import { render } from "./TicTacToe.vue?vue&type=template&id=463c84d2"
import script from "./TicTacToe.vue?vue&type=script&lang=js"
export * from "./TicTacToe.vue?vue&type=script&lang=js"

import "./TicTacToe.vue?vue&type=style&index=0&id=463c84d2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__